export default {
  nav: {
    connectWallet: "Connect",
    connected: "Connected",
    switchLanguage: "Language",
    menu: {
      extinct: "The Lost Beast",
      iceAge: "Ice Age",
      cretaceous: "Cretaceous",
      market: "Market",
      nftGame: "GameFi",
      museum: "Museum",
      irlEvents: "IRL",
      announcement: "Announcement",
      more: "More",
      whitepaper: "Whitepaper",
      purchase: "NFT Market",
    },
  },
  home: {
    iceAge: "ICE AGE",
    year: "year",
    month: "month",
    individual: "individual",
    cretaceous: "CRETACEOUS",
    roadmap: "PROJECT ROUTE DIAGRAM",
    similarFate:
      "The first Ice Age NFT series features 10 iconic animals, each carrying a profound ecological warning. The mammoth symbolizes the drastic impact of climate change, with its extinction serving as a stark reminder of the need to address the climate crisis and prevent modern species from facing a similar fate.",
    day: "day",
    firstBatch: "MYSTERT GUEST",
    toBeSoon: "TO BE SOON",
    sell: "sell",
    FreeMarketRelease: "FREE MARKET",
    OfficialWebsiteRelease: "FIRE SALE",
    OfficialWebsiteReleaseTime: "JAN 20, 2025",
    time: "JAN 2025",
    ChainTravel: "GAMEFI",
    title:
      "The world is not inherited from our ancestors, but borrowed from our descendants.",
    subTitle:
      '"The Vanishing Beasts" is an innovative NFT ecosystem project that combines digital art, blockchain technology, and environmental awareness. Centered around rare and endangered animals, our goal is to raise awareness about the conservation of these species and environmental protection in a creative way. We aim to bring extinct giants back to life in the virtual world. By telling the stories of these animals, we strive to reconstruct their lost memories and inspire each participant to contribute to the preservation of nature.',
    info: "“Only when the last tree is cut down, the last river poisoned, and the last fish caught, will humanity realize that money cannot be eaten.” — Cree Proverb. This iconic quote encapsulates the core message of The Lost Beasts: protecting nature is not only about safeguarding ecosystems but also about securing the future of humanity.This project is more than a digital collection journey; it is a global environmental initiative. Leveraging Web3 technology, we have created a multidimensional ecosystem that spans both online and offline, including a virtual museum, interactive blockchain games, and public welfare collaborations. Every participant will play an essential role in this environmental movement, joining us to write the future chapter of nature conservation.",
    ourSeries: "OUR COLLECTIONS",
    comingSoon: "COMING",
    moreEvents: "More Events",
    projectRoadmap: "Project Roadmap",
    timeline: {
      waitlist: "Waitlist",
      sale: "Sale",
      airdrop: "Airdrop",
      tokenLaunch: "Token Launch",
      websiteRelease: "Website Release",
      websiteReleaseTime: "December 24, 2025",
      nftSale: "First NFT Sale",
      nftSaleTime: "January 20, 2025",
      marketRelease: "Free Market Release",
      marketReleaseTime: "Coming Soon",
      gameRelease: "Chain Game",
      gameReleaseTime: "Coming Soon",
    },
    quote: "NEVER GONNA GIVE YOU UP.",
    copyright: "2024",
    goBuy: "Purchase Now",
  },

  child: {
    title: "Ice Age: A Warning Encased in Ice",
    subTitle:
      "Ice Age is the first subproject of The Lost Beasts, focusing on animals that went extinct during the Ice Age. It reconstructs their stories to inspire reflection on environmental conservation.\n" +
      "\n" +
      "The Ice Age was a period of wonder and transformation in Earth's history. As climate change and ecological imbalances unfolded, many magnificent creatures disappeared, becoming symbols of memory. Their extinction not only highlights the fragility of nature but also serves as a warning about the environmental challenges faced by modern society.",
    Climate: "Climate Crisis and Ecological Imbalance",
    ClimateContent:
      "The first Ice Age NFT series features 10 iconic animals, each bearing profound ecological warnings. The mammoth symbolizes the severe impacts of climate change, reminding us of the urgent need to address this crisis to prevent modern species from meeting a similar fate. The saber-toothed tiger’s extinction highlights the devastating effects of ecological imbalance on apex predators, underscoring the importance of protecting food chain integrity. Meanwhile, the moa’s disappearance reflects the destructive consequences of human activity on ecosystems, emphasizing the critical need to preserve habitats for biodiversity.\n",
    BalanceTitle: "A Call for Habitat and Natural Balance\n",
    BalanceContent:
      "The loss of the woolly rhinoceros reveals the catastrophic impact of overexploitation, reinforcing the importance of sustainable development. The slow lifestyle of the giant ground sloth serves as a metaphor for ecological balance, with its extinction warning that even gradual disruptions to nature can lead to irreversible outcomes. Similarly, the disappearance of the cave bear illustrates how habitat loss drives species to extinction, highlighting the necessity of safeguarding natural environments for life to thrive.",
    Ecosystems: "Guardians of Biodiversity and Ecosystems",
    EcosystemsContent:
      "The story of the giant eagle symbolizes the fragility of aerial ecosystems, urging the protection of flying creatures and their habitats. The majestic Irish elk, with its beauty and demise, underscores the importance of preserving biodiversity to maintain ecological harmony. As a key architect of wetland ecosystems, the giant beaver’s extinction serves as a stark reminder of the urgency to protect water resources. Lastly, the arctic wolf’s story of adaptability and cooperation reflects the essence of natural equilibrium, with its disappearance illustrating the dire consequences of environmental degradation and the need for collective human effort to protect nature.",
    descendants:
      "The world is not inherited from our ancestors but borrowed from our descendants",
    descendantsTitle:
      "The Lost Beasts is a tribute to the past and a commitment to the future. By deeply integrating digital technology and environmental values, it breathes new life into extinct animals while sounding an urgent alarm for ecological protection.\n" +
      "\n" +
      "Through the Ice Age NFT series, you become part of a collective effort to protect nature. Whether by exploring the virtual museum, engaging in blockchain games, or supporting real-world conservation actions, every choice you make contributes to the planet’s future. Join us to craft a future epic of nature conservation through digital art, ensuring that the spark of life never fades!",
    Ecological:
      "Ecological Warnings and Calls for Protecting Endangered Species",
    EcologicalContent:
      "The first Ice Age NFT series features 10 iconic animals, each extinction carrying a vital ecological warning. The mammoth, saber-toothed tiger, and moa highlight the devastating impacts of climate change, ecological imbalance, and human activity on nature. The woolly rhinoceros, giant ground sloth, and cave bear reveal the importance of sustainable development and habitat protection for maintaining natural balance. The giant eagle, Irish elk, giant beaver, and arctic wolf symbolize the fragility and beauty of sky, land, and wetland ecosystems, underscoring the urgent need to protect biodiversity, water resources, and ecological harmony. Together, these stories call humanity to action in safeguarding our shared planet.",
    ourDescendants:
      "The world is not inherited from our ancestors but borrowed from our descendants",
    ourDescendantsContent:
      "The world is not inherited from our ancestors but borrowed from our descendants\n" +
      "\n" +
      "The Lost Beasts is a tribute to the past and a commitment to the future. By deeply integrating digital technology and environmental values, it breathes new life into extinct animals while sounding an urgent alarm for ecological protection.\n" +
      "\n" +
      "Through the Ice Age NFT series, you become part of a collective effort to protect nature. Whether by exploring the virtual museum, engaging in blockchain games, or supporting real-world conservation actions, every choice you make contributes to the planet’s future. Join us to craft a future epic of nature conservation through digital art, ensuring that the spark of life never fades!",
  },
  notice: {
    title: "Announcements",
    noData: "No Data",
    readMore: "Read More",
    date: "Date",
    search: "search",
    back: "back",
    noMore: "No More",
    loading: "loading...",
    category: {
      all: "All",
      news: "News",
      updates: "Updates",
      events: "Events",
    },
  },
  market: {
    Assetagreement: "Token Standard",
    PublicAssetChain: "Chain",
    ConfirmationOfPurchase: "Confirmation of purchase",
    Ethereum: "Ethereum",
    ContractAddress: "Contract Address",
    owner: "owner",
    sellingPrice: "price",
    return: "return",
    shareLink: "share link",
    TransactionHistory: "Transaction History",
    search: "search",
    detail: "detail",
    name: "Name",
    Price: "Price",
    Time: "Time",
    Operation: "Operation",
    sellOut: "Sold Out",
    PleaseConnectWallet: "Please Connect Wallet",
  },
  whitepaper: {
    title: "The Lost Beasts NFT Tokenomics",
    content: {
      w1: "The Lost Beasts is a series of digital tokens compliant with the ERC-721 token standard. The Lost Beasts has no functions, utility, or intrinsic value, and there is no promise or expectation of any financial return, profit, interest, or dividend.",

      w2: "The Lost Beasts has no development roadmap, nor is there any commitment or expectation to develop any ecosystem for The Lost Beasts.",

      w3: "The Lost Beasts is completely useless and intended solely for entertainment purposes.",

      w4: "To avoid misunderstanding and without limiting the generality of the above, The Lost Beasts is not and does not intend to:",

      w5: "• Serve as a medium of exchange accepted by the public (or a section of the public) for the payment of goods or services, or for the discharge of debts;",

      w6: "• Be designed or intended for any person to use as a means of payment for any goods or services;",

      w7: "• Entitle holders to exchange The Lost Beasts NFTs for goods or services;",

      w8: "• Represent money (including e-money);",

      w9: "• Serve as a digital representation of a capital markets product, security, share, debenture, unit in a collective investment scheme, derivatives contract, commodity, or any other financial instrument or investment;",

      w10: "• Be considered a capital markets product, security, share, debenture, unit in a collective investment scheme, derivatives contract, commodity, or other financial instrument or investment in any jurisdiction;",

      w11: "• Represent any shareholding, participation, right (including but not limited to voting rights), title, stake, or interest in any entity, enterprise, or undertaking;",

      w12: "• Represent any entitlement to exercise voting rights within the The Lost Beasts ecosystem;",

      w13: "• Represent any entitlement to fees, dividends, revenue, profits, or investment returns;",

      w14: "• Represent rights under a contract for differences or any other contract aimed at securing a profit or avoiding a loss;",

      w15: "• Be refundable or exchangeable for cash (or its equivalent value in any other digital asset);",

      w16: "• Represent any indebtedness.",

      w17: "The Lost Beasts makes no guarantees or commitments to list its NFTs on any exchange.",

      w18: "Disclaimer",

      w19: "This whitepaper and the website are provided solely for general informational purposes. They do not constitute a prospectus, offering document, or an offer of securities, capital markets products, or digital payment tokens. They are not an invitation for investment or an offer to sell any product, instrument, or asset (whether digital or otherwise).",

      w20: "The information contained herein may not be exhaustive and does not form part of any contractual relationship. No representation, warranty, or undertaking is provided as to the accuracy or completeness of the information contained herein.",

      w21: "Updates and Statements",

      w22: "The information in this Whitepaper is current as of the version date stated on its cover. Information related to token sales, The Lost Beasts functionalities, financial conditions, or future planning may change over time. Consequently, the information in this document may become outdated, and The Lost Beasts team is under no obligation to update or correct it.",
    },
  },
};
